import './public-path'
import { createApp } from 'vue'
import App from './App.vue'
import { createAppRouter } from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import i18n from './locale'
// 导入全局样式
import '@/assets/css/global.css'
// 导入图标管理
import { registerIcons } from '@/utils/icons'
// 导入全局错误处理
import errorHandler from '@/utils/errorHandler'
// 导入 qiankun 配置
import { registerMallMicroApp, startMicroApp } from '@/microApp/mall'

// 引入简单的axios修复，解决toUpperCase错误
import './utils/simpleAxiosFix'

let app = null
let router = null

async function render (props = {}) {
  const { container, app_id } = props
  console.log('Rendering app with container:', container)
  console.log('App ID:', app_id)

  // 保存 app_id 到全局属性
  if (app_id) {
    window.__SUB_APP_ID__ = app_id
  }

  // 动态创建路由，根据是否在 qiankun 环境中设置 base
  const base = window.__POWERED_BY_QIANKUN__ ? (window.__SUB_APP_ID__ === 10004 ? '/digital-card' : '/subapp') : '/'
  console.log('Router base:', base)

  router = createAppRouter(base, app_id)

  app = createApp(App)

  // 注册图标
  registerIcons(app)

  // 注册全局错误处理
  app.config.errorHandler = (err, vm, info) => {
    console.error('全局错误:', err)
    console.error('Vue实例:', vm)
    console.error('错误信息:', info)
  }

  // 注册全局属性
  app.config.globalProperties.$appName = '数字名片'
  if (app_id) {
    app.config.globalProperties.$appId = app_id
  }

  // 注册插件
  app.use(router)
  app.use(store)
  app.use(i18n)
  // 配置Element Plus，确保所有组件都能被正确解析
  app.use(ElementPlus, {
    // 配置选项
    size: 'default',
    zIndex: 3000
  })

  // 初始化全局错误处理
  errorHandler.init(app, store)

  // 将store挂载到window对象上，以便api/auth.js能够访问
  window.$store = store

  // ✅ 先恢复登录状态（token、userInfo），再挂载应用，消除竞态条件
  store.dispatch('initTheme')
  await store.dispatch('initApp')
  console.log('initApp 完成，store token:', store.state.user.token)
  console.log('initApp 完成，store userInfo.id:', store.state.user.userInfo?.id)

  // 挂载应用
  const mountContainer = container ? container.querySelector('#app') : '#app'
  console.log('Mounting to:', mountContainer)
  app.mount(mountContainer)
}

// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  render()
  // 启动微前端框架
  startMicroApp()
  // 不在启动时立即注册 qiankun，而是在需要时才注册
}

// qiankun生命周期钩子
export async function bootstrap () {
  console.log('[vue] vue app bootstraped')
}

export async function mount (props) {
  console.log('[vue] props from main framework', props)
  render(props)
}

export async function unmount () {
  console.log('[vue] app unmounting')
  if (app) {
    app.unmount()
    app = null
  }
  if (router) {
    router = null
  }
}
